import PageMeta from "~/components/common/meta";
import { Photos } from "~/components/staff/photos";

export const PhotosScreen = () => {
  return (
    <>
      <PageMeta title="Photos | Art Handler" />
      <Photos />
    </>
  );
};
